import {
  DeliveryMethodsTypes,
  IBranch,
} from "@/api/AppApi/services/company/interfaces/ICompany";
import { IKeyValue } from "@/api/AppApi/services/filters/interfaces/IGetFilters";
import { createAtomWithSafeStorage } from "@/utils/atom/atomStorageUtil";
import { atom } from "jotai";
export interface IReceivingSettingsStorage {
  receiving_type?: DeliveryMethodsTypes;
  delivery_address_type?: "address" | "current";
  address?: {
    address_name?: string;
    country_id?: IKeyValue;
    city_id?: IKeyValue;
    area_id?: IKeyValue;
  };
  delivery_time_type?: "custom" | "now";
  delivery_time?: string | null;
  receiving_branch?: IBranch; //
  pickup_time_type?: "custom" | "now";
  pickup_time?: string | null;
}
export const receivingSettingsAtom =
  createAtomWithSafeStorage<IReceivingSettingsStorage | null>(
    "receiving-settings",
    null,
  );

export const receivingBranchAtom = atom<IBranch | null>(null);

export const disableSubmitBtnAtom = atom<boolean>(false);
export const NoAvailableBranchAtom = atom<boolean>(false);
